import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./reducers/auth";
import organizationReducer from "./reducers/organizationSlice";
import roleReducer from "./reducers/roleSlice";
import userOrganizationsReducer from "./reducers/userOrganizationsSlice";
import badgesReducer from "./reducers/badgesDetails";
import employeePerformanceOverviewReducer from "./reducers/employeePerformanceOverview";
import rewardDashboardReducer from "./reducers/rewardDashboard";
import notificationReducer from "./reducers/notification";
import userPermissionsReducer from "./reducers/userPermissionSlice";
import leaderBoardReducer from "./reducers/leaderBoard";
import graphDataReducer from "./reducers/graphDataSlice";
import q2m2ApplicationsReducer from "./reducers/q2m2ApplicationsSlice";
import modalReducer from "./reducers/modalSlice";
import eduVideosReducer from "./reducers/videoSectionSlice";
import questionsReducer from "./reducers/questionsSectionSlice";
import acFormateReducer from "./reducers/acFormateSlice";
import quizzesReducer from "./reducers/quizzesSlice"
import onlyQuizReducer from "./reducers/onlyQuizSectionSlice"
import riskAnalysisReducer from "./reducers/riskAnalysisSlice";
import employeePdfReducer from "./reducers/employeePdfSlice";

// ✅ redux-persist imports
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// ✅ persist config for auth only
const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["token", "currentUser", "isLoggedIn"], // what to persist
};

// ✅ wrap auth reducer
const persistedAuthReducer = persistReducer(
  authPersistConfig,
  authSlice.reducer
);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer, // ✅ persisted
    organization: organizationReducer,
    role: roleReducer,
    userOrganizations: userOrganizationsReducer,
    badgesDetails: badgesReducer,
    employeePerformanceOverview: employeePerformanceOverviewReducer,
    rewardDashboard: rewardDashboardReducer,
    notifications: notificationReducer,
    userPermissions: userPermissionsReducer,
    leaderBoard: leaderBoardReducer,
    graphData: graphDataReducer,
    q2m2Applications: q2m2ApplicationsReducer,
    modal: modalReducer,
    eduVideos: eduVideosReducer,
    questions: questionsReducer,
    acFormate: acFormateReducer,
    quizzes:quizzesReducer,
    onlyQuiz:onlyQuizReducer,
    riskAnalysis: riskAnalysisReducer,
    employeePdfs: employeePdfReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
});

// ✅ export persistor
export const persistor = persistStore(store);

export default store;
